import { messageTypes } from './messages.types'

export const INITIAL_STATE = {
  messages: {
    loading: false,
    uploadProgressData: {
      percentage: null, // null or number (starting from zero)
      fileType: null, // type of file being uploaded (ex: image or ...)
    },
    uploadError: '',
    confirmUploadedData: null,
    userInput: {},
    sendingFile: null,
    voiceRecording: false,
    recordingAudio: null,
    offlineMessage: {
      sendStatus: false,
      beforeSendingMessage: false,
      forceGetUserDetails: false,
      message: null,
    },
    fetchMoreMessages: {
      status: false,
      page: 0,
    },
    disableInput: {
      status: false,
      discription: '',
    },
    socketConnectionError: {
      status: false,
      discription: '',
    },
    data: [],
  },
  audioStream: null,
  connectionError: false,
  // FIXME: typo
  defaultOnlineAgent: null,
  defaultTeam: null,
  user: {},
  getUserFromApi: false,
  userformStatus: {},
  activeDepartment: {
    loading: false,
    data: null,
  },
  departments: {
    loading: false,
    data: [],
  },
  acceptedChat: {},
  replyingMessage: null,
  selectedQuestion: null,
  teamsChatInputShouldHide: [],
  showGreetingInput: true,
}

const updateDepartments = (state, newData) => {
  return {
    ...state,
    departments: {
      ...state.departments,
      ...newData,
    },
  }
}

// returns specified default team from server. in case no default team specified from server (shouldn't happen normally) considers first team as default and returns it
const getDefaultTeam = (teams) => {
  const defaultTeam = teams.filter((team) => team.default)[0]

  if (!defaultTeam) {
    return teams[0]
  }

  return defaultTeam
}

const messagesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case messageTypes.SET_REMOVE_MSG_BY_TMP_ID: {
      const { teamId, tmpId } = action.payload

      const targetDepartment = state.departments.data.find((d) => d._id === teamId)

      const otherDepartments = state.departments.data.filter((d) => d._id !== teamId)

      return {
        ...state,
        departments: {
          ...state.departments,
          data: [
            ...otherDepartments,
            {
              ...targetDepartment,
              messages: targetDepartment.messages.filter((m) => m.tmpId !== tmpId),
            },
          ],
        },
      }
    }

    case messageTypes.SET_UPLOAD_ERROR:
      return {
        ...state,
        messages: {
          ...state.messages,
          uploadError: action.payload.errMsg,
        },
      }

    case messageTypes.SET_CONFIRM_UPLOADED_DATA:
      return {
        ...state,
        messages: {
          ...state.messages,
          confirmUploadedData: action.payload,
        },
      }

    case messageTypes.SET_UPLOAD_PROGRESS_DATA:
      return {
        ...state,
        messages: {
          ...state.messages,
          uploadProgressData: {
            percentage: action.payload.percentage,
            fileType: action.payload.fileType,
          },
        },
      }

    case messageTypes.SET_NEW_MESSAGE: {
      let { teamId = state.defaultTeam._id, message } = action.payload

      const newDepartments = state.departments.data.map((department) => {
        // if passed teamId is "all" message will be sent to all departments
        if (teamId === 'all' || department._id === teamId) {
          return {
            ...department,
            messages: [...department.messages, { ...message, teamId: department._id }],
          }
        }
        return department
      })

      return updateDepartments(state, { data: newDepartments })
    }

    case messageTypes.SEND_MESSAGE: {
      const { teamId, message } = action.payload

      const newDepartments = state.departments.data.map((department) => {
        if (department._id === teamId) {
          return {
            ...department,
            messages: [...department.messages, message],
          }
        }
        return department
      })

      return updateDepartments(state, { data: newDepartments })
    }

    case messageTypes.SET_NOT_SEEN_RECEIVED_MSGS: {
      const notSeenReceivedMsgsByTeam = action.payload

      const newDepartments = state.departments.data.map((department) => {
        const dpId = department._id

        if (notSeenReceivedMsgsByTeam[dpId] !== undefined) {
          return {
            ...department,
            notSeenMsgsCount: notSeenReceivedMsgsByTeam[dpId],
          }
        }
        return department
      })

      return updateDepartments(state, { data: newDepartments })
    }

    case messageTypes.INCREMENT_NOT_SEEN_RECEIVED_MSGS: {
      const teamId = action.payload

      const newDepartments = state.departments.data.map((department) => {
        const dpId = department._id

        if (dpId === teamId) {
          return {
            ...department,
            notSeenMsgsCount: department.notSeenMsgsCount + 1,
          }
        }

        return department
      })

      return updateDepartments(state, { data: newDepartments })
    }

    case messageTypes.SET_DEPARTMENTS: {
      let departmentWithMessage = action.payload.map((department) => {
        return {
          ...department,
          messages: [],
          msgLoadDetails: { page: 1, allFetched: false },
          notSeenMsgsCount: 0,
        }
      })

      const defaultTeam = getDefaultTeam(action.payload)

      const updatedState = updateDepartments(state, {
        loading: false,
        data: departmentWithMessage,
      })

      return {
        ...updatedState,
        defaultTeam,
      }
    }

    case messageTypes.SET_ACTIVE_DEPARTMENT:
      return {
        ...state,
        activeDepartment: {
          loading: false,
          data: action.payload,
        },
      }

    case messageTypes.SET_ACCEPTED_CHAT: {
      const { teamId = state.defaultTeam._id, agentInfo, meta } = action.payload

      return {
        ...state,
        acceptedChat: {
          ...state.acceptedChat,
          [teamId]: {
            status: true,
            agentInfo: { ...agentInfo },
            meta,
          },
        },
      }
    }

    case messageTypes.REMOVE_ACCEPTED_CHAT: {
      const teamId = action.payload || state.defaultTeam._id
      const clonedAcceptedChatObj = Object.assign({}, state.acceptedChat)
      delete clonedAcceptedChatObj[teamId]

      return {
        ...state,
        acceptedChat: clonedAcceptedChatObj,
      }
    }

    case messageTypes.SET_MESSAGE_STATUS: {
      let { status, message_id, team_id = state.defaultTeam._id } = action.payload

      let adaptedTeams = state.departments.data.map((department) => {
        if (department._id === team_id) {
          let msg = department.messages.map((message) => {
            if (message.tmpId === message_id) {
              return {
                ...message,
                status,
                progress: action.payload?.progress,
              }
            } else {
              return message
            }
          })
          return {
            ...department,
            messages: msg,
          }
        } else {
          return department
        }
      })

      return updateDepartments(state, { data: adaptedTeams })
    }

    case messageTypes.SET_FORM_MESSAGE:
      return {
        ...state,
        messages: {
          ...state.messages,
          data: [...state.messages.data, action.payload],
        },
      }

    case messageTypes.REMOVE_FORM_MESSAGE: {
      const { teamId, formId } = action.payload

      const newDepartments = state.departments.data.map((department) => {
        if (department._id !== teamId) {
          const newMessages = department.messages.filter((item) => {
            return item.formId !== formId
          })
          return { ...department, messages: newMessages }
        }
        return department
      })

      return updateDepartments(state, { data: newDepartments })
    }

    case messageTypes.SET_USER_INPUT: {
      const { teamId, input } = action.payload
      return {
        ...state,
        messages: {
          ...state.messages,
          userInput: {
            ...state.messages.userInput,
            [teamId]: input,
          },
        },
      }
    }

    case messageTypes.SET_VOICE_RECORDING:
      return {
        ...state,
        messages: {
          ...state.messages,
          voiceRecording: action.payload,
        },
      }

    case messageTypes.SET_USER_FORM_STATUS:
      return {
        ...state,
        userformStatus: action.payload,
      }

    case messageTypes.SET_FETCH_MORE_MESSAGES: {
      const { teamId, ...others } = action.payload
      const newDepartments = state.departments.data.map((department) => {
        if (department._id === teamId) {
          const newMsgLoadDetails = { ...department.msgLoadDetails, ...others }

          return { ...department, msgLoadDetails: newMsgLoadDetails }
        }

        return department
      })

      return updateDepartments(state, { data: newDepartments })
    }

    case messageTypes.SET_OLD_MESSAGES: {
      const { teamId, messages } = action.payload

      const newDepartments = state.departments.data.map((department) => {
        if (department._id === teamId) {
          let newMessages = [...messages, ...department.messages]

          if (state.acceptedChat[teamId]?.meta?.notSeenWidget !== undefined) {
            const notSeenWidget = state.acceptedChat[teamId].meta?.notSeenWidget

            // get all messages count(ignoring bot messages)
            const userMessagesCount = newMessages.filter((msg) => !msg.botId).length

            // set seen status for all messages
            if (notSeenWidget === 0) {
              newMessages = newMessages.map((msg) => {
                msg.status = 'seen'
                return msg
              })
            }
            // separate sent and seen messages
            else {
              let lastSeenMessageIndex = 0
              newMessages = newMessages.map((msg) => {
                // ignore bot messages
                if (msg.botId) return msg

                if (lastSeenMessageIndex < userMessagesCount - notSeenWidget) msg.status = 'seen'
                else msg.status = 'sent'

                lastSeenMessageIndex++
                return msg
              })
            }
          }

          return {
            ...department,
            messages: newMessages,
          }
        }

        return department
      })

      return updateDepartments(state, { data: newDepartments })
    }

    case messageTypes.SET_DISABLE_INPUT:
      return {
        ...state,
        messages: {
          ...state.messages,
          disableInput: action.payload,
        },
      }

    case messageTypes.SET_SOCKET_CONNECTION_ERROR:
      return {
        ...state,
        messages: {
          ...state.messages,
          socketConnectionError: action.payload,
        },
      }

    case messageTypes.SET_RECORDING_AUDIO:
      return {
        ...state,
        messages: {
          ...state.messages,
          recordingAudio: action.payload,
        },
      }

    case messageTypes.SET_FEEDBACK_BOX_VALUES: {
      const { teamId, conversationId, ...values } = action.payload
      const newDepartments = state.departments.data.map((team) => {
        if (team._id === teamId) {
          const messages = team.messages.map((message) => {
            if (message.type === 'feedback' && message.conversationId === conversationId) {
              return {
                ...message,
                ...values,
              }
            }

            return message
          })

          return {
            ...team,
            messages,
          }
        }

        return team
      })

      return updateDepartments(state, { data: newDepartments })
    }

    case messageTypes.SET_OFFLINE_MESSAGE:
      return {
        ...state,
        messages: {
          ...state.messages,
          offlineMessage: action.payload,
        },
      }

    case messageTypes.UPDATE_ACCEPTED_CHAT_AVATAR: {
      const teamId = action.payload.teamId
      const newAvatar = action.payload.avatar
      const isBot = action.payload.isBot

      return {
        ...state,
        acceptedChat: {
          ...state.acceptedChat,
          [teamId]: {
            ...state.acceptedChat[teamId],
            avatar: newAvatar,
            isBot,
          },
        },
      }
    }

    case messageTypes.SET_CONNECTION_ERROR:
      return {
        ...state,
        connectionError: action.payload,
      }

    case messageTypes.SET_CURRENT_USER:
      return {
        ...state,
        user: action.payload,
      }

    case messageTypes.SET_AUDIO_STREAM:
      return {
        ...state,
        audioStream: action.payload,
      }

    case messageTypes.GET_USER_FROM_API:
      return {
        ...state,
        getUserFromApi: action.payload,
      }
    case messageTypes.SET_DEFAULT_ONLINE_AGENT:
      return {
        ...state,
        defaultOnlineAgent: action.payload,
      }
    case messageTypes.SET_DEFAULT_TEAM:
      return {
        ...state,
        defaultTeam: action.payload,
      }

    case messageTypes.SET_REPLYING_MESSAGE:
      return {
        ...state,
        replyingMessage: action.payload,
      }

    case messageTypes.SET_EDITED_MESSAGE: {
      const clonedDepartments = [...state.departments.data]
      let editedMessages = []

      const selectedDpIndex = clonedDepartments.findIndex(
        (department) => department._id === state.activeDepartment.data,
      )
      if (selectedDpIndex !== -1) {
        editedMessages = clonedDepartments[selectedDpIndex]?.messages.map((msg) => {
          if (msg.id === action.payload.messageId) {
            return {
              ...msg,
              content: action.payload.message,
              edited: true,
            }
          }
          return msg
        })

        clonedDepartments[selectedDpIndex].messages = editedMessages
      }

      return {
        ...state,
        departments: {
          ...state.departments,
          data: clonedDepartments,
        },
      }
    }

    case messageTypes.SET_MSG_STATUS:
      // const updatedStatus = action.payload.status;
      // const messageId = action.payload.messageId;

      return state

    case messageTypes.SET_MSG_ID:
      // const prevId = action.payload.prevId;
      // const newId = action.payload.newId;

      return state

    case messageTypes.SET_SEEN_STATUS_FOR_ALL_MESSAGES: {
      const clonedDepartmentsData = [...state.departments.data]

      const dpIndex = clonedDepartmentsData.findIndex((dp) => dp._id === action.payload.teamId)
      if (dpIndex !== -1) {
        const chats = clonedDepartmentsData[dpIndex].messages.map((msg) => {
          msg.status = 'seen'
          return msg
        })
        clonedDepartmentsData[dpIndex].messages = chats
      }

      return updateDepartments(state, { data: clonedDepartmentsData })
    }

    case messageTypes.SET_MESSAGE_ID: {
      const correctedDepartments = state.departments.data.map((dp) => {
        if (action.payload.teamId === 'all' || dp._id === action.payload.teamId) {
          return {
            ...dp,
            messages: dp.messages.map((chat) => {
              if (chat.tmpId === action.payload.prevId) chat.id = action.payload.newId
              return chat
            }),
          }
        }
        return dp
      })

      return updateDepartments(state, { data: correctedDepartments })
    }

    case messageTypes.SET_SELECTED_QUESTION:
      return {
        ...state,
        selectedQuestion: action.payload,
      }

    case messageTypes.CHANGE_BOT_MSG_TO_TEXT: {
      const { tmpId, teamId, content } = action.payload
      const clonedDepartmentsData = [...state.departments.data]

      const dpIndex = clonedDepartmentsData.findIndex((dp) => dp._id === teamId)

      if (dpIndex !== -1) {
        const chats = clonedDepartmentsData[dpIndex].messages.map((msg) => {
          if (msg.tmpId === tmpId) {
            return {
              ...msg,
              type: 'text',
              content,
            }
          }

          return msg
        })

        clonedDepartmentsData[dpIndex].messages = chats
      }

      return updateDepartments(state, { data: clonedDepartmentsData })
    }

    case messageTypes.SET_FORM_STATUS: {
      const { formId, status, teamId } = action.payload
      const clonedDepartmentsData = [...state.departments.data]

      const dpIndex = clonedDepartmentsData.findIndex((dp) => dp._id === teamId)

      if (dpIndex !== -1) {
        const chats = clonedDepartmentsData[dpIndex].messages.map((msg) => {
          if (msg.formId === formId) {
            return {
              ...msg,
              formStatus: status,
            }
          }

          return msg
        })

        clonedDepartmentsData[dpIndex].messages = chats
      }

      return updateDepartments(state, { data: clonedDepartmentsData })
    }

    case messageTypes.HIDE_CHAT_INPUT_FOR_TEAM: {
      return {
        ...state,
        teamsChatInputShouldHide: [...state.teamsChatInputShouldHide, ...action.payload],
      }
    }

    case messageTypes.SET_SHOW_GREETING_INPUT: {
      return {
        ...state,
        showGreetingInput: action.payload,
      }
    }

    case messageTypes.REMOVE_MESSAGE: {
      const { teamId, createdAt, msgType } = action.payload

      const clonedDepartmentsData = [...state.departments.data]

      const dpIndex = clonedDepartmentsData.findIndex((dp) => dp._id === teamId)

      if (dpIndex !== -1) {
        const chats = clonedDepartmentsData[dpIndex].messages.filter((msg) => {
          const msgCreatedAt = new Date(msg.createdAt).valueOf()
          const areTheSame = msgCreatedAt === createdAt && msg.type === msgType

          return !areTheSame
        })

        clonedDepartmentsData[dpIndex].messages = chats
      }

      return updateDepartments(state, { data: clonedDepartmentsData })
    }
    case messageTypes.OPEN_WIDGET_AUTO_MSG_ACTION: {
      return {
        ...state,
        activeDepartment: {
          loading: false,
          data: action.payload.teamId,
        },
      }
    }

    case messageTypes.SET_SENT_CLOSE_BUTTON: {
      const { data, teamId } = action.payload
      if (
        !state.acceptedChat[teamId] ||
        !state.acceptedChat[teamId].meta ||
        !state.acceptedChat[teamId].meta.letUserClose
      )
        return state

      const currentLetUserClose = state.acceptedChat[teamId].meta.letUserClose

      return {
        ...state,
        acceptedChat: {
          ...state.acceptedChat,
          [teamId]: {
            ...state.acceptedChat[teamId],
            meta: {
              ...state.acceptedChat[teamId].meta,
              letUserClose: {
                ...currentLetUserClose,
                value: data.value,
                ...(data.by !== undefined && { by: data.by }),
                ...(data.agentInfo !== undefined && { agentInfo: data.agentInfo }),
              },
            },
          },
        },
      }
    }

    default:
      return state
  }
}

export default messagesReducer
